export const parsePaginatedResponse = (response) => {
  const payload = response?.data ?? response ?? {};

  if (Array.isArray(payload)) {
    return {
      results: payload,
      count: payload.length,
    };
  }

  const results = Array.isArray(payload.results) ? payload.results : [];
  return {
    results,
    count: Number(payload.count ?? results.length),
    page: Number(payload.page ?? 1),
    page_size: Number(payload.page_size ?? results.length),
  };
};
